'use strict';

var reactDom = require('react-dom');
var jsxRuntime = require('react/jsx-runtime');

// src/portal.tsx
var ReactPortalComponent = ({
  children,
  wrapperId
}) => {
  if (typeof document === "undefined") return null;
  const wrapper = document.getElementById(wrapperId || "");
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children: reactDom.createPortal(children, wrapper || document.body) });
};

// src/components/ReactPortal.tsx
var ReactPortal = ReactPortalComponent;

exports.ReactPortal = ReactPortal;
